import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import Well from '$components/ProductDashboard/Well';
import styles from './styles.scss';

import shapeWavesSrc from './shapeWaves.png';

const EARLY_ACCESS_SLUGS = ['amc-8', 'finra-series-6']; // TODO(finra-series-6)

class Welcome extends Component {
  render() {
    const { currentUser, product } = this.props;
    const { nickname } = currentUser;
    const { slug } = product;
    const earlyAccess = _.includes(EARLY_ACCESS_SLUGS, slug) ? ' (early access)' : null;

    return (
      <div className={styles.background}>
        <Well>
          <div className={styles.layout}>
            <div className={styles.nameBlock}>
              <div className={styles.title}>
                Welcome{nickname ? `, ${nickname}` : null}
              </div>
              <div className={styles.subtitle}>
                {product.shortName}
                {earlyAccess}
              </div>
            </div>
            <div className={styles.dateBlock}>
              <div className={styles.title}>
                <i className="fad fa-calendar-star" />
                <span>&nbsp; Today</span>
              </div>
              <div className={styles.subtitle}>
                {moment().format('dddd, DD MMM YYYY')}
              </div>
            </div>
            <div className={styles.shape}>
              <img src={shapeWavesSrc} />
            </div>
          </div>
        </Well>
      </div>
    );
  }
}

export default Welcome;
